import type { InjectionKey } from 'vue'

import type { IAmplitudePlugin } from './amplitude.types'

export const AmplitudeKey: InjectionKey<IAmplitudePlugin> = Symbol('Amplitude')
